import { formatRecommendedAges } from '../helpers/helpers'

/** Activity cards. Not implemented as components, but used as such in different parts of the web */
export function displayActivityItem (activity) {
  const link = `/activities/${activity.slug}`

  return `
  <div class="places-list-item-wrapper">
    <div id="${activity.name}" class="places-list-grid-item">
      <a href="${link}">
        <div class="place-item-img-container">
          <img class="place-item-image" src="${activity.main_image}" alt="${activity.slug}">
        </div>
        <div class="place-item-info-container">
          <div class="place-item-info-first">
            <h2 class="place-item-name">${activity.name}</h2>
          </div>
          <div class="place-item-info-second">
            ${activity.show_vendor ? `<span class="place-item-category">${activity.vendor.name}</span>` : ''}
            <span class="place-item-age">
              <i class="fas fa-child"></i>${formatRecommendedAges(JSON.parse(activity.recommended_ages))}
            </span>
          </div>
        </div>
        <div class="place-item-address-container">
          <p class="place-item-address">
            <i class="fas fa-info"></i>
            ${activity.subtitle}
          </p>
        </div>
        <div id="place-item-book">Reserva</div>
      </a>
    </div>
  </div>
  `
}
